import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'CATEGORY_FORM'
export const CategoryFormAction = createFormAction(FORM_KEY)